import { useState } from "react";
import { ReactComponent as PenIcon } from "../../../../assets/svg/icons/penEdit.svg";
import { ReactComponent as SearchIcon } from "../../../../assets/svg/icons/search.svg";
import "./styles.css";
import { useEditOnboarding } from "../../../../hooks/useEditOnboarding";

type TableVisualizationRowProps = {
  microAreaManagement: IMicroAreaManagementContent;
  isHistory: boolean;
};

const formatDateWithoutTimezone = (dateString: string): string => {
  if(dateString && dateString.length > 0) {
    const [year, month, day] = dateString.split(' ')[0].split('-');
    return `${day}/${month}/${year.slice(-2)}`;
  }
  return "";
};

export default function TableVisualizationRow({
  microAreaManagement,
  isHistory
}: TableVisualizationRowProps) {
  const {
    setOptionForm,
    setDefaultValue
  } = useEditOnboarding();

  const frequency = new Map<string, string>()
  frequency.set("WEEKLY", "Semanal")
  frequency.set("BIWEEKLY", "Bisemanal")
  frequency.set("MONTHLY", "Mensal")

  function formatDefaultValuesPasteureManagement(data: IMicroAreaManagementContent) {
    return {
      id: data.id,
      microAreas: data.micro_area.map((microArea: any) => (
        {
          label: `${microArea.farm.initials}-${microArea.area.initials}-${microArea.initials}`,
          value: microArea.id,
          info: microArea
        }
      )),
      type: {
        label: data.type.name,
        value: data.type.id
      },
      monitor: {
        label: data.type.monitoring_types[0].name,
        value: data.type.monitoring_types[0].id
      },
      frequency: data.frequency,
      days_of_week: data.days_of_week,
      execution_per_day: data.execution_per_day,
      start_date: data.start_date,
      end_date: data.deactivated_at,
      requirement_in: data.requirement_in,
      requirement_out: data.requirement_out,
      farm: data.micro_area[0].farm,
      area: data.micro_area[0].area
    }
  }

  return (
    <tr>
      <td>{microAreaManagement.micro_area_management_group_initials}</td>
      <td>{microAreaManagement.micro_area[0].farm.name}</td>
      <td>{microAreaManagement.micro_area[0].area.name}</td>
      <td title={microAreaManagement.micro_area.map((ma: any) => ma.initials).join(", ")}>{microAreaManagement.micro_area.length == 1 ? microAreaManagement.micro_area[0].initials : `${microAreaManagement.micro_area.length} pastos`}</td>
      {microAreaManagement.type && <td>
        {microAreaManagement.type.name}
        <br />
        {microAreaManagement.type.monitoring_types[0].name}
      </td>}
      <td>
        {microAreaManagement.frequency ? frequency.get(microAreaManagement.frequency) : ""}
        <br />
        {microAreaManagement.days_of_week && microAreaManagement.days_of_week.length != 0 ? `${microAreaManagement.days_of_week.length} dias` : ""}
      </td>
      <td>{formatDateWithoutTimezone(microAreaManagement.start_date)}</td>
      {isHistory && (
        <td>{formatDateWithoutTimezone(microAreaManagement.deactivated_at)}</td>
      )}
      <td className="infoButton">
        {isHistory ?
          <SearchIcon
            onClick={() => {
              setOptionForm("pasture-management")
              setDefaultValue(formatDefaultValuesPasteureManagement(microAreaManagement))
            }}
            className="searchIcon"
          />
          :
          <PenIcon
            onClick={() => {
              setOptionForm("pasture-management")
              setDefaultValue(formatDefaultValuesPasteureManagement(microAreaManagement))
            }}
          />}
      </td>
    </tr>
  );
}
